module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"description":"WareXは、価格・場所などの条件を踏まえた倉庫検索から入出荷の進捗までチームで一元管理できるシェアリング倉庫サービスです。見積り不要・従量課金・設備や人の手配不要・入出荷管理・チームでの一元管理という5つの特徴で倉庫利用をサポートします。"}}')
  delete Component.options._Ctor
}
